export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_22.bdd8b8bf.jpg";